import './blocks/assets-manager.js';
import './blocks/dependencies-manager.js';
import './components/ippm-packages.js';
import './components/ippm-alert.js';
import './scripts/upload.js';

import 'kemet-ui/dist/components/kemet-upload/kemet-upload.js';
import 'kemet-ui/dist/components/kemet-upload/kemet-upload-file.js';
